import React, { useRef, useState } from 'react'
import DigitalPortfolio from './DigitalPortfolio'
import WorkAndEducation from './WorkAndEducation'

const TabData = ({ kidId, data }) => {
  const tabDivRef = useRef(null)

  const [activeTab, setActiveTab] = useState(0)

  const handleClick = (index) => {
    setActiveTab(index)
  }

  const scrollToTabs = () => {
    if (tabDivRef.current) {
      tabDivRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <>
      <div className="tabs-data">
        <div className="tabs-compititions d-flex align-items-center justify-content-center text-center flex-wrap mb-4 mb-lg-5">
          <div className={`tab  me-2  ${activeTab === 0 ? 'active' : ''}`} onClick={() => handleClick(0)}>
            Digital Portfolio
          </div>
          <div className={`tab ${activeTab === 1 ? 'active' : ''}`} onClick={() => handleClick(1)}>
            Profile
          </div>
        </div>
        <div className="tab-content-compititions">
          {activeTab === 0 && <DigitalPortfolio kidId={kidId} data={data} scrollToTabs={scrollToTabs} />}
          {activeTab === 1 && <WorkAndEducation data={data} scrollToTabs={scrollToTabs} />}
        </div>
      </div>
    </>
  )
}

export default TabData
